import './locale';

import { container } from 'tsyringe';

import { ConfigServiceImpl } from '@/v1/main/usecases';
import {
    DeviceProvider,
    LanguageProvider,
    ThemeProvider,
} from '@/v1/main/views/Provider';

import { App } from './App';

const Main: React.FC = () => {
    const usecase = container.resolve(ConfigServiceImpl);
    return (
        <DeviceProvider usecase={usecase}>
            <ThemeProvider usecase={usecase}>
                <LanguageProvider usecase={usecase}>
                    <App />
                </LanguageProvider>
            </ThemeProvider>
        </DeviceProvider>
    );
};

export default Main;
